/**
 * Shared styling utilities and CSS-in-JS helpers
 * Inspired by Park UI's styling approach
 */

import { css } from "../lib/panda";
import { tokens } from "../tokens";

// Common style presets
export const presets = {
  // Container styles
  container: {
    base: css({
      maxWidth: "80rem",
      margin: "0 auto",
      padding: "0 1.5rem",
    }),
    fluid: css({
      width: "100%",
      padding: "0 1.5rem",
    }),
  },

  // Card styles
  card: {
    base: css({
      backgroundColor: "white",
      borderRadius: tokens.borderRadius.lg,
      boxShadow: tokens.boxShadow.base,
      padding: tokens.spacing[6],
    }),
    elevated: css({
      backgroundColor: "white",
      borderRadius: tokens.borderRadius.xl,
      boxShadow: tokens.boxShadow.lg,
      padding: tokens.spacing[8],
    }),
  },

  // Button base styles
  button: {
    base: css({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "0.75rem",
      fontSize: "1.125rem",
      fontWeight: "600",
      cursor: "pointer",
      border: "none",
      transition: "all 0.2s ease",
      "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
      },
    }),
    sm: css({
      padding: "0.5rem 1rem",
      fontSize: "0.875rem",
    }),
    md: css({
      padding: "0.5rem 1.5rem",
      fontSize: "1.125rem",
    }),
    lg: css({
      padding: "0.75rem 2rem",
      fontSize: "1.125rem",
    }),
    // Header button specific styles
    header: css({
      padding: "0.5rem 1.5rem",
      borderRadius: "9999px",
      fontSize: "1.125rem",
      fontWeight: "600",
    }),
  },

  // Text styles
  text: {
    heading: {
      h1: css({
        fontFamily: tokens.typography.fontFamily.heading,
        fontSize: tokens.typography.fontSize["5xl"],
        fontWeight: tokens.typography.fontWeight.bold,
        lineHeight: tokens.typography.lineHeight.tight,
        color: tokens.colors.brand.accent,
      }),
      h2: css({
        fontFamily: tokens.typography.fontFamily.heading,
        fontSize: tokens.typography.fontSize["4xl"],
        fontWeight: tokens.typography.fontWeight.bold,
        lineHeight: tokens.typography.lineHeight.tight,
        color: tokens.colors.brand.accent,
      }),
      h3: css({
        fontFamily: tokens.typography.fontFamily.heading,
        fontSize: tokens.typography.fontSize["3xl"],
        fontWeight: tokens.typography.fontWeight.semibold,
        lineHeight: tokens.typography.lineHeight.normal,
        color: tokens.colors.neutral[800],
      }),
    },
    body: {
      base: css({
        fontFamily: tokens.typography.fontFamily.sans,
        fontSize: tokens.typography.fontSize.base,
        lineHeight: tokens.typography.lineHeight.normal,
        color: tokens.colors.neutral[700],
      }),
      large: css({
        fontFamily: tokens.typography.fontFamily.sans,
        fontSize: tokens.typography.fontSize.lg,
        lineHeight: tokens.typography.lineHeight.relaxed,
        color: tokens.colors.neutral[700],
      }),
    },
  },
} as const;
